/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const SatelliteRadio = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 24 24" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M17.13 22.57H13V9.75a2.65 2.65 0 1 0-1.44 0v12.82H7.37a.72.72 0 1 0 0 1.43h9.76a.72.72 0 1 0 0-1.43zM17.09 12.81a.69.69 0 0 0 .5-.2 7.63 7.63 0 0 0 .26-10.78.71.71 0 0 0-1 1 6.21 6.21 0 0 1-.21 8.77.71.71 0 0 0 .45 1.21z" /><path d="M21.09.25a.7.7 0 0 0-1 0 .71.71 0 0 0 0 1 8.5 8.5 0 0 1-.29 12 .71.71 0 0 0 0 1 .7.7 0 0 0 .52.22.72.72 0 0 0 .49-.19A10 10 0 0 0 21.09.25zM6.16 12.67a.7.7 0 0 0 .52.22.72.72 0 0 0 .52-1.21 6.19 6.19 0 0 1 .21-8.76.7.7 0 0 0 0-1 .71.71 0 0 0-1 0 7.65 7.65 0 0 0-.25 10.75z" /><path d="M1.61 7.18a8.39 8.39 0 0 1 2.64-5.94.73.73 0 0 0 0-1 .71.71 0 0 0-1 0c-3.959 3.771-4.115 10.036-.35 14a.73.73 0 0 0 .52.23.74.74 0 0 0 .5-.2.72.72 0 0 0 0-1 8.4 8.4 0 0 1-2.31-6.09z" /></g>
      </g>
    </svg>
  </span>
);

SatelliteRadio.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

SatelliteRadio.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default SatelliteRadio;
